module.exports = __webpack_public_path__ + "static/media/bettr-proxies.3fb2bd46.png";